import { ImageTaggedTextProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/utils/TaggedText/ImageTaggedTextProperties";
import { GameMessageBarProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameMessageBarProperties";
import { GameFontStyle } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/style/GameFontStyle";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { Locale } from "@lib/titan2/dist/game/manager/LanguageManager";
import { Point } from "pixi.js";
export class MessageBarLandscapeProperties extends GameMessageBarProperties {
    constructor() {
        super();
        this.messageFieldProperties = new YouCouldWinTaggedTextLandscapeProperties();
        this.messageInterval = 3000;
        this.maxLength = new Map([
            [Locale.ENGLISH, 36]
        ]);
        this.position.set(973, 10);
    }
}
export class YouCouldWinTaggedTextLandscapeProperties extends ImageTaggedTextProperties {
    constructor() {
        super();
        this.textFieldProperties = new TextFieldProperties(GameFontStyle.GAME_MESSAGES, undefined, undefined, ControlConstants.LEFT, undefined);
        this.size = new Point(750, 60);
        this.position.set(0, -6);
        this.textFieldProperties.autoResize = false;
    }
}
//# sourceMappingURL=MessageBarLandscapeProperties.js.map